import { render } from "./IconCheckmark.vue?vue&type=template&id=54f68fa2"
import script from "./IconCheckmark.vue?vue&type=script&lang=js"
export * from "./IconCheckmark.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__